<template>
  <div>
    <div v-if="$store.getters.isKiosk"></div>
    <div v-else class="page noselect">

      <div class="fixBg maxw"></div>
      <div style="z-index:2; position: relative;">
        <v-container grid-list-md class="" style="margin-bottom: -10px;">
          <v-layout row wrap>

            <v-flex xs12>
              <div class="logoContainer pt-8 pb-8">
                <img class="" style="max-height: 200px;" src="../assets/placeholder6-opti.png">
              </div>
            </v-flex>

            <!--          <v-flex xs12>-->
            <!--            <div class="spacer-15"></div>-->
            <!--&lt;!&ndash;            <div style="height: 2vh"></div>&ndash;&gt;-->
            <!--          </v-flex>-->

            <!--          <v-flex xs12 class="pb-3 d-flex">-->
            <!--            <CategoryCard class="pointer" @click.native.passive="$ebus.$emit('goto',{name:'RatingFeedback'})"-->
            <!--                          label="Rating" :nomargin="false" icon="mdi-beer"></CategoryCard>-->
            <!--          </v-flex>-->

            <!--            <div class="mobile pa-3">-->

<!--            <div>DEBUG showOrderModeSwitcher {{showOrderModeSwitcher}}</div>-->
<!--            <div>DEBUG availableOrderModes {{$store.getters.availableOrderModes}}</div>-->
            <v-flex xs12 v-if="showOrderModeSwitcher">
              <div class="pt-5 pb-5">
                <OrderModeSwitcher></OrderModeSwitcher>
              </div>
            </v-flex>
            <!--            </div>-->
            <!--            <div class="tablet pa-3 pb-7">-->
            <!--              <OrderModeSwitcher-->
            <!--              >-->
            <!--              </OrderModeSwitcher>-->
            <!--            </div>-->

            <!--            <div class="mt-4">-->
            <!--              DEBUG Gewählter Modus: <strong>{{ userOrderMode }}</strong>-->
            <!--            </div>-->


            <v-flex xs12 class="">
              <CmsBlock blockName="Startseite Oben"></CmsBlock>
            </v-flex>

            <v-flex xs6 class="pb-3 d-flex">
              <CategoryCard class="pointer" @click.native.passive="gotoSpeisen"
                            label="Speisen" :nomargin="false" icon="mdi-silverware-fork-knife"></CategoryCard>
              <!--                <BrandButton content="Speisen"-->
              <!--                             @click.native.passive="$ebus.$emit('goto',{name:'Speisen'})"></BrandButton>-->
              <!--                <BrandButton content="Lunch"-->
              <!--                             @click.native.passive="$ebus.$emit('goto',{name:'SpeisenProdukte', params: {catname: 'Lunch'}, scrollTarget:''})"></BrandButton>-->
            </v-flex>

            <v-flex xs6 class="pb-3 d-flex">
              <CategoryCard class="pointer" @click.native.passive="gotoDrinks"
                            label="Getränke" :nomargin="false" icon="mdi-beer"></CategoryCard>
            </v-flex>

            <v-flex xs12 class="pb-3 d-flex" v-if="$store.getters.inhouse && $store.state.enableKellnerruf">
              <CategoryCard class="pointer" @click.native.passive="goKellnerruf"
                            label="Kellnerruf" :nomargin="false" pngicon="waiter" :inverse="true"></CategoryCard>
            </v-flex>

            <v-flex xs12 class="pb-3 d-flex" v-if="$store.getters.enableStempel">
              <CategoryCard class="pointer" @click.native.passive="$ebus.$emit('goto',{name:'Stempelkarte'})"
                            bg="Stempelkarte"
                            label="Stempelkarte" :nomargin="false" pngicon="StempelkartenIcon"></CategoryCard>
            </v-flex>

            <v-flex xs12 class="pb-3 d-flex" v-if="!$store.getters.inhouse && ($store.getters.enableTakeawayPay || $store.getters.enableTakeawayOhnePay)">
              <CategoryCard class="pointer" @click.native.passive="$ebus.$emit('goto',{name:'Abholzeiten'})"
                            label="Abholzeiten" :nomargin="false" icon="mdi-clock-outline"></CategoryCard>
            </v-flex>

            <v-flex xs12 class="pb-3 d-flex" v-if="!$store.getters.inhouse && ($store.getters.enableDeliveryPay || $store.getters.enableDeliveryOhnePay)">
              <CategoryCard class="pointer" @click.native.passive="$ebus.$emit('goto',{name:'Lieferzeiten'})"
                            label="Lieferzeiten" :nomargin="false" icon="mdi-clock-outline"></CategoryCard>
            </v-flex>

            <v-flex xs12 class="pb-3 d-flex" v-if="!$store.getters.inhouse && ($store.getters.enableDeliveryPay || $store.getters.enableDeliveryOhnePay)">
              <CategoryCard class="pointer" @click.native.passive="$ebus.$emit('gotoPage','Liefergebiet')"
                            label="Liefergebiet" :nomargin="false" icon="mdi-map-marker-radius"></CategoryCard>
            </v-flex>

            <v-flex xs12 class="pb-3 d-flex" v-if="$store.state.enableNews">
              <CategoryCard class="pointer" @click.native.passive="gotoAktuelles"
                            label="Aktuelles" :nomargin="false" icon="mdi-bell"></CategoryCard>
            </v-flex>
            <!--          <v-flex xs12 class="pb-3 d-flex">-->
            <!--            <CategoryCard class="pointer" @click.native.passive="$ebus.$emit('goto',{name:'Page', params: {name: 'Abholzeiten'}})"-->
            <!--                          label="Abholzeiten" :nomargin="false" icon="mdi-bell"></CategoryCard>-->
            <!--          </v-flex>-->

            <v-flex xs12 class="pb-3 d-flex" v-if="$store.getters.lastOrders.length > 0">
              <CategoryCard class="pointer" @click.native.passive="gotoLastOrders"
                            label="Meine Bestellungen" :nomargin="false" icon="mdi-history"></CategoryCard>
            </v-flex>

            <v-flex xs12 class="pb-3 d-flex" v-if="showInstall">
              <CategoryCard class="pointer" @click.native.passive="clickInstallApp"
                            label="App installieren" :nomargin="false" icon="mdi-exit-to-app"></CategoryCard>
            </v-flex>

            <v-flex xs12 class="">
              <CmsBlock blockName="Startseite Unten"></CmsBlock>
            </v-flex>

          </v-layout>
          <div class="logoPadding"></div>
        </v-container>
      </div>


      <!--    <div class="absLogosBottom">-->
      <!--      <v-container grid-list-xs class="">-->
      <!--        <v-layout row wrap>-->
      <!--          <v-flex xs6>-->
      <!--            <div class="logoContainer">-->
      <!--              <img class="restLogo sharpImage bottomLogo pointer" src="../assets/powered_by_qsignal.png"-->
      <!--                   @click="$ebus.$emit('gotoWebsite', 'https://www.lodgekuehlungsborn.de/de/home.html')"-->
      <!--              >-->
      <!--            </div>-->
      <!--          </v-flex>-->
      <!--          <v-flex xs6>-->
      <!--            <div class="logoContainer">-->
      <!--              <img class="restLogo sharpImage bottomLogo pointer" src="../assets/placeholder6-opti.png"-->
      <!--                   @click="$ebus.$emit('gotoWebsite', 'https://www.deckbeachclub.com/de/home.html')"-->
      <!--              >-->
      <!--            </div>-->
      <!--          </v-flex>-->
      <!--        </v-layout>-->
      <!--      </v-container>-->
      <!--      <div class="spacer"></div>-->
      <!--    </div>-->


      <!--    <div class="mobile">-->

      <!--      <div class="mHero">-->
      <!--        <div class="fixBg maxw">-->
      <!--          <div style="position: relative;" class="away text-center">-->
      <!--            &lt;!&ndash;                        src="https://skapps.s3.eu-central-1.amazonaws.com/erranteappimages/logo-tran-black.png"&ndash;&gt;-->
      <!--            <div class="d-inline-block restLogoContainer">-->
      <!--              <img class="restLogo sharpImage" src="../assets/placeholder6-opti.png"-->
      <!--              >-->
      <!--            </div>-->
      <!--            &lt;!&ndash;                        <div class="appImage"></div>&ndash;&gt;-->
      <!--          </div>-->
      <!--        </div>-->

      <!--        <div class="mActionsContainer homeCard">-->
      <!--          <div class="cardContent">-->
      <!--            <div class="mActions">-->
      <!--              <v-container>-->
      <!--                <v-layout row wrap>-->
      <!--                  &lt;!&ndash; DEBUG Buttons&ndash;&gt;-->
      <!--                  &lt;!&ndash;                  <v-flex xs6 class="mAction"&ndash;&gt;-->
      <!--                  &lt;!&ndash;                          @click.passive="debugSound">&ndash;&gt;-->
      <!--                  &lt;!&ndash;                    <BrandButton content="debug sound"></BrandButton>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                  </v-flex>&ndash;&gt;-->

      <!--                  &lt;!&ndash;                                    <v-flex xs6 class="mAction" @click.passive="$ebus.$emit('deleteCacheStorage')">&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                        <BrandButton content="Delete Cache"></BrandButton>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                    </v-flex>&ndash;&gt;-->

      <!--                  &lt;!&ndash;                                    <v-flex xs6 class="mAction" @click.passive="$ebus.$emit('goto',{name:'Registrierung'})">&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                        <BrandButton content="Register"></BrandButton>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                    </v-flex>&ndash;&gt;-->
      <!--                  <v-flex v-if="lastOrdersPayableInhouse.length > 0" xs6-->
      <!--                          class="mAction" @click.passive="$ebus.$emit('goto',{name:'CheckoutInhouseTable'})">-->
      <!--                    <BrandButton :negative="true" content="Checkout"></BrandButton>-->
      <!--                  </v-flex>-->

      <!--                  <v-flex xs6 class="mAction" @click.passive="gotoSpeisen">-->
      <!--                    <BrandButton content="Speisen"></BrandButton>-->
      <!--                  </v-flex>-->

      <!--                  <v-flex xs6 class="mAction" @click.passive="gotoDrinks">-->
      <!--                    <BrandButton content="Getränke"></BrandButton>-->
      <!--                  </v-flex>-->

      <!--                  &lt;!&ndash;                                    <v-flex xs6 class="mAction" v-if="$store.getters.inhouse"&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                            @click.passive="gotoCheckin">&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                        <BrandButton content="Check-in"></BrandButton>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                    </v-flex>&ndash;&gt;-->

      <!--                  <v-flex xs6 class="mAction" v-if="$store.getters.inhouse && $store.state.enableKellnerruf"-->
      <!--                          @click.passive="goKellnerruf">-->
      <!--                    <BrandButton content="Kellnerruf"></BrandButton>-->
      <!--                  </v-flex>-->

      <!--                  &lt;!&ndash;                                    <v-flex xs6 class="mAction" @click.passive="gotoShop">&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                        <BrandButton content="Shop"></BrandButton>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                    </v-flex>&ndash;&gt;-->

      <!--                  <v-flex v-if="!$store.getters.inhouse" xs6 class="mAction" @click.passive="gotoAbholzeiten">-->
      <!--                    <BrandButton content="Abholzeiten"></BrandButton>-->
      <!--                  </v-flex>-->
      <!--                  <v-flex xs6 class="mAction" v-if="$store.getters.enableStempel"-->
      <!--                          @click.passive="$ebus.$emit('goto',{name:'Stempelkarte'})">-->
      <!--                    <BrandButton content="Stempelkarte"></BrandButton>-->
      <!--                  </v-flex>-->
      <!--                  <v-flex xs6 class="mAction" @click.passive="gotoAktuelles" v-if="$store.state.enableNews">-->
      <!--                    <BrandButton content="Aktuelles"></BrandButton>-->
      <!--                  </v-flex>-->
      <!--                  <v-flex xs6 class="mAction" @click.passive="gotoLastOrders">-->
      <!--                    <BrandButton content="Bestellungen"></BrandButton>-->
      <!--                  </v-flex>-->

      <!--                  &lt;!&ndash;                                    <v-flex xs6 class="mAction"&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                            @click.passive="gotoWebsite('https://www.gesellenstube-olympia.de/#reservierungen')">&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                        <BrandButton content="Reservierung"></BrandButton>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                    </v-flex>&ndash;&gt;-->

      <!--                  &lt;!&ndash;                                    <v-flex xs12 class="mAction"&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                            @click.passive="gotoWebsite('https://www.gesellenstube-olympia.de/produkt/gutschein/')">&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                        <BrandButton content="Gutschein"></BrandButton>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                    </v-flex>&ndash;&gt;-->

      <!--                  &lt;!&ndash;                                    <v-flex xs12 class="mAction"&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                            @click.passive="gotoWebsite('https://www.gesellenstube-olympia.de/')">&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                        <BrandButton content="Webseite"></BrandButton>&ndash;&gt;-->
      <!--                  &lt;!&ndash;                                    </v-flex>&ndash;&gt;-->

      <!--                </v-layout>-->
      <!--              </v-container>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->

      <!--      </div>-->
      <!--    </div>-->


      <!--    <div class="tablet text-center">-->
      <!--      <div class="fixBg maxw">-->
      <!--        <v-container class="prelative" grid-list-lg>-->
      <!--          <div class="tabletLogo maxw away">-->
      <!--            <img class="" src="../assets/placeholder6-opti.png"-->
      <!--            ></div>-->
      <!--        </v-container>-->

      <!--        &lt;!&ndash;                <div style="position: relative;" class="away text-center">&ndash;&gt;-->
      <!--        &lt;!&ndash;                    <div class="d-inline-block restLogoContainer">&ndash;&gt;-->
      <!--        &lt;!&ndash;                        <img class="restLogo invertImg" src="../assets/logo-black.png"&ndash;&gt;-->
      <!--        &lt;!&ndash;                        >&ndash;&gt;-->
      <!--        &lt;!&ndash;                    </div>&ndash;&gt;-->
      <!--        &lt;!&ndash;                </div>&ndash;&gt;-->
      <!--      </div>-->
      <!--      &lt;!&ndash;            <div class="appImage"></div>&ndash;&gt;-->

      <!--      &lt;!&ndash;            <v-img&ndash;&gt;-->
      <!--      &lt;!&ndash;                    class="heroImage"&ndash;&gt;-->
      <!--      &lt;!&ndash;                    :src="require('../assets/hero_bg.jpg')"&ndash;&gt;-->
      <!--      &lt;!&ndash;                    cover&ndash;&gt;-->
      <!--      &lt;!&ndash;                    position="center center"&ndash;&gt;-->
      <!--      &lt;!&ndash;                    height="440"&ndash;&gt;-->
      <!--      &lt;!&ndash;            />&ndash;&gt;-->

      <!--      <div style="z-index:2; padding-top: 400px">-->
      <!--        <v-container class="prelative" grid-list-lg>-->

      <!--          <v-layout row wrap>-->

      <!--            &lt;!&ndash;                        <v-flex xs6 class="mAction" @click.passive="$ebus.$emit('goto',{name:'Registrierung'})">&ndash;&gt;-->
      <!--            &lt;!&ndash;                            <BrandButton :negative="true" content="Register"></BrandButton>&ndash;&gt;-->
      <!--            &lt;!&ndash;                        </v-flex>&ndash;&gt;-->

      <!--            <v-flex v-if="lastOrdersPayableInhouse.length > 0" xs6-->
      <!--                    class="mAction" @click.passive="$ebus.$emit('goto',{name:'CheckoutInhouseTable'})">-->
      <!--              <BrandButton :negative="true" content="Checkout"></BrandButton>-->
      <!--            </v-flex>-->

      <!--            <v-flex xs6 class="mAction" @click.passive="gotoSpeisen">-->
      <!--              <BrandButton :negative="true" content="Speisen"></BrandButton>-->
      <!--            </v-flex>-->

      <!--            <v-flex xs6 class="mAction" @click.passive="gotoDrinks">-->
      <!--              <BrandButton :negative="true" content="Getränke"></BrandButton>-->
      <!--            </v-flex>-->

      <!--            &lt;!&ndash;                        <v-flex xs6 class="mAction" v-if="$store.getters.inhouse" @click.passive="gotoCheckin">&ndash;&gt;-->
      <!--            &lt;!&ndash;                            <BrandButton :negative="true" content="Check-in"></BrandButton>&ndash;&gt;-->
      <!--            &lt;!&ndash;                        </v-flex>&ndash;&gt;-->

      <!--            <v-flex xs6 class="mAction" v-if="$store.getters.inhouse && $store.state.enableKellnerruf"-->
      <!--                    @click.passive="goKellnerruf">-->
      <!--              <BrandButton :negative="true" content="Kellnerruf"></BrandButton>-->
      <!--            </v-flex>-->

      <!--            &lt;!&ndash;                        <v-flex xs6 class="mAction" @click.passive="gotoShop">&ndash;&gt;-->
      <!--            &lt;!&ndash;                            <BrandButton :negative="true" content="Shop"></BrandButton>&ndash;&gt;-->
      <!--            &lt;!&ndash;                        </v-flex>&ndash;&gt;-->

      <!--            <v-flex v-if="!$store.getters.inhouse" xs6 class="mAction" @click.passive="gotoAbholzeiten">-->
      <!--              &lt;!&ndash;                        <v-flex xs12 lg12 class="mAction" @click.passive="gotoAktuelles">&ndash;&gt;-->
      <!--              <BrandButton :negative="true" content="Abholzeiten"></BrandButton>-->
      <!--            </v-flex>-->
      <!--            <v-flex xs6 class="mAction" v-if="$store.getters.enableStempel"-->
      <!--                    @click.passive="$ebus.$emit('goto',{name:'Stempelkarte'})">-->
      <!--              <BrandButton :negative="true" content="Stempelkarte"></BrandButton>-->
      <!--            </v-flex>-->
      <!--            <v-flex xs6 class="mAction" @click.passive="gotoAktuelles" v-if="$store.state.enableNews">-->
      <!--              &lt;!&ndash;                        <v-flex xs12 lg12 class="mAction" @click.passive="gotoAktuelles">&ndash;&gt;-->
      <!--              <BrandButton :negative="true" content="Aktuelles"></BrandButton>-->
      <!--            </v-flex>-->

      <!--            <v-flex xs6 class="mAction" @click.passive="gotoLastOrders">-->
      <!--              &lt;!&ndash;                        <v-flex xs12 lg12 class="mAction" @click.passive="gotoAktuelles">&ndash;&gt;-->
      <!--              <BrandButton :negative="true" content="Bestellungen"></BrandButton>-->
      <!--            </v-flex>-->

      <!--            &lt;!&ndash;                        <v-flex xs12 lg6 class="mAction"&ndash;&gt;-->
      <!--            &lt;!&ndash;                                @click.passive="gotoWebsite('https://www.gesellenstube-olympia.de/produkt/gutschein/')">&ndash;&gt;-->
      <!--            &lt;!&ndash;                            <BrandButton :negative="true" content="Gutschein"></BrandButton>&ndash;&gt;-->
      <!--            &lt;!&ndash;                        </v-flex>&ndash;&gt;-->

      <!--            &lt;!&ndash;                        <v-flex xs12 class="mAction"&ndash;&gt;-->
      <!--            &lt;!&ndash;                                @click.passive="gotoWebsite('https://www.gesellenstube-olympia.de/')">&ndash;&gt;-->
      <!--            &lt;!&ndash;                            <BrandButton :negative="true" content="Webseite"></BrandButton>&ndash;&gt;-->
      <!--            &lt;!&ndash;                        </v-flex>&ndash;&gt;-->

      <!--          </v-layout>-->
      <!--        </v-container>-->
      <!--      </div>-->
      <!--      &lt;!&ndash;            <div class="hero">&ndash;&gt;-->
      <!--      &lt;!&ndash;                <v-img&ndash;&gt;-->
      <!--      &lt;!&ndash;                        :src="require('../assets/bg2.jpg')"&ndash;&gt;-->
      <!--      &lt;!&ndash;                        cover&ndash;&gt;-->
      <!--      &lt;!&ndash;                        position="center top"&ndash;&gt;-->
      <!--      &lt;!&ndash;                        height="500"&ndash;&gt;-->
      <!--      &lt;!&ndash;                />&ndash;&gt;-->
      <!--      &lt;!&ndash;                <div class="absLogo maxw maxh">&ndash;&gt;-->
      <!--      &lt;!&ndash;                    <div class="d-flex justify-center align-center" style="height: 65%;">&ndash;&gt;-->
      <!--      &lt;!&ndash;                        <div class="text-center">&ndash;&gt;-->
      <!--      &lt;!&ndash;                            <div><img class="appFiliale" src="../assets/App-Filiale-s.png" alt="App-Filiale"></div>&ndash;&gt;-->
      <!--      &lt;!&ndash;                            <div class="bald">bald mit Shop!</div>&ndash;&gt;-->
      <!--      &lt;!&ndash;                        </div>&ndash;&gt;-->
      <!--      &lt;!&ndash;                    </div>&ndash;&gt;-->
      <!--      &lt;!&ndash;                </div>&ndash;&gt;-->

      <!--      &lt;!&ndash;                                <div class="absShopnow pointer hidden-sm-and-down" @click.passive="gotoSortiment">&ndash;&gt;-->
      <!--      &lt;!&ndash;                                    <img src="../assets/Entdecke.png">&ndash;&gt;-->
      <!--      &lt;!&ndash;                                </div>&ndash;&gt;-->

      <!--      &lt;!&ndash;                &lt;!&ndash;                TODO activate for online&ndash;&gt;&ndash;&gt;-->
      <!--      &lt;!&ndash;                &lt;!&ndash;                <div class="absShopnow pointer hidden-sm-and-down" @click.passive="gotoSortiment">&ndash;&gt;&ndash;&gt;-->
      <!--      &lt;!&ndash;                &lt;!&ndash;                    <img src="../assets/Shop-Now-v4-tilt.png">&ndash;&gt;&ndash;&gt;-->
      <!--      &lt;!&ndash;                &lt;!&ndash;                </div>&ndash;&gt;&ndash;&gt;-->
      <!--      &lt;!&ndash;            </div>&ndash;&gt;-->


      <!--      &lt;!&ndash;            grid-list-md to grid-list-lg or grid-list-xl&ndash;&gt;-->

      <!--      &lt;!&ndash;            <v-container grid-list-lg>&ndash;&gt;-->
      <!--      &lt;!&ndash;                <div style="margin-top: -100px" class="equal-cards cardhover">&ndash;&gt;-->
      <!--      &lt;!&ndash;                    <v-layout row wrap class="justify-space-around">&ndash;&gt;-->
      <!--      &lt;!&ndash;                        <v-flex xs10 md4>&ndash;&gt;-->
      <!--      &lt;!&ndash;                            <CardOpeningHours></CardOpeningHours>&ndash;&gt;-->
      <!--      &lt;!&ndash;                            &lt;!&ndash;                            <CardLieferzeiten></CardLieferzeiten>&ndash;&gt;&ndash;&gt;-->
      <!--      &lt;!&ndash;                        </v-flex>&ndash;&gt;-->
      <!--      &lt;!&ndash;                        <v-flex xs10 md4>&ndash;&gt;-->
      <!--      &lt;!&ndash;                            &lt;!&ndash;                            <CardSortimentButtons></CardSortimentButtons>&ndash;&gt;&ndash;&gt;-->
      <!--      &lt;!&ndash;                            &lt;!&ndash;                            <CardSortiment></CardSortiment>&ndash;&gt;&ndash;&gt;-->
      <!--      &lt;!&ndash;                            <CardNeuigkeiten></CardNeuigkeiten>&ndash;&gt;-->
      <!--      &lt;!&ndash;                            &lt;!&ndash;                            <CardOnlineShop></CardOnlineShop>&ndash;&gt;&ndash;&gt;-->
      <!--      &lt;!&ndash;                        </v-flex>&ndash;&gt;-->
      <!--      &lt;!&ndash;                        <v-flex xs10 md4>&ndash;&gt;-->
      <!--      &lt;!&ndash;                            &lt;!&ndash;                            TODO activate for online&ndash;&gt;&ndash;&gt;-->
      <!--      &lt;!&ndash;                            &lt;!&ndash;                            <CardAbholung></CardAbholung>&ndash;&gt;&ndash;&gt;-->
      <!--      &lt;!&ndash;                            <CardCoupons></CardCoupons>&ndash;&gt;-->
      <!--      &lt;!&ndash;                        </v-flex>&ndash;&gt;-->
      <!--      &lt;!&ndash;                    </v-layout>&ndash;&gt;-->
      <!--      &lt;!&ndash;                </div>&ndash;&gt;-->
      <!--      &lt;!&ndash;            </v-container>&ndash;&gt;-->


      <!--      &lt;!&ndash;            <v-container>&ndash;&gt;-->
      <!--      &lt;!&ndash;                <CollageOne cat-name="Brote"></CollageOne>&ndash;&gt;-->

      <!--      &lt;!&ndash;                &lt;!&ndash;                <div class="myTitle"><h1>Unsere Brötchen</h1></div>&ndash;&gt;&ndash;&gt;-->
      <!--      &lt;!&ndash;                <CollageOne cat-name="Brötchen"></CollageOne>&ndash;&gt;-->

      <!--      &lt;!&ndash;                <CollageOne cat-name="Kuchen"></CollageOne>&ndash;&gt;-->

      <!--      &lt;!&ndash;                &lt;!&ndash;                <div class="myTitle"><h1>Unsere Süße Teilchen</h1></div>&ndash;&gt;&ndash;&gt;-->
      <!--      &lt;!&ndash;                <CollageOne cat-name="Süßes"></CollageOne>&ndash;&gt;-->
      <!--      &lt;!&ndash;            </v-container>&ndash;&gt;-->
      <!--    </div>-->


      <FixBasket></FixBasket>

    </div>
  </div>

</template>

<script>
import {mapState, mapMutations} from 'vuex';
// @ is an alias to /src
import * as appManager from '@/vendor/appManager'
import {ebus} from '../vendor/ebus'
import store from '../store/store'
// import * as appManager from '../vendor/appManager'
import * as qconst from '../vendor/qconstants';
// import * as util from '../vendor/util'
// import * as firebaseUtil from '../firebase/firebaseUtil'


// import AppHead from "../components/AppHead";
// import MySlider2 from "../components/MySlider2";
// import CategoryCard from "../components/CategoryCard";
// import CardLieferzeiten from "../cards/CardLieferzeiten";
// import CardAbholung from "../cards/CardAbholung";
// import CardOpeningHours from "../cards/CardOpeningHours";
// import {offerMixin} from "../mixins/offerMixin";
// import CardOnlineShop from "../cards/CardOnlineShop";
import FixBasket from "../components/FixBasket";
// import SliderCategories from "../components/SliderCategories";
// import SliderLotionen from "../components/SliderLotionen";
// import SliderDeko from "../components/SliderDeko";
import SortimentCards from "../components/SortimentCards";
import Oeffnungszeiten from "../components/oeffnungszeiten";
import BrandButton from "../components/BrandButton";
import * as util from "@/vendor/util";
import CmsBlock from "@/components/CmsBlock.vue";
import CategoryCard from "@/components/CategoryCard.vue";
import {isIos} from "@/vendor/util";
import OrderModeSwitcher from "../orderModeSwitch/OrderModeSwitcher.vue";
import {usecase$delivery, usecase$takeAway} from "../vendor/qconstants";
// import SliderAktionen from "../components/SliderAktionen";
// import CardSortiment from "../cards/CardSortiment";
// import CardNeuigkeiten from "../cards/CardNeuigkeiten";
// import CardCoupons from "../cards/CardCoupons";
// import SortimentCards from "../components/SortimentCards";
// import SortimentCards from "../components/SortimentCards";
// import CardSortimentButtons from "../cards/CardSortimentButtons";

export default {
  name: 'Home',
  // mixins: [offerMixin],
  components: {
    OrderModeSwitcher,
    CategoryCard,
    CmsBlock,
    BrandButton,
    Oeffnungszeiten,
    // SliderAktionen,
    // SortimentCards,
    // SliderDeko,
    // SliderLotionen,
    // SliderCategories,
    // CardCoupons,
    // SortimentCards,
    // CardNeuigkeiten,
    // SortimentCards,
    // CardSortimentButtons,
    // CardSortiment,
    FixBasket,
    // CardOpeningHours,
    // CardAbholung,
    // CardLieferzeiten,
    // CardOnlineShop,
    // MySlider2,
    // CategoryCard,
    // AppHead,
  },
  data() {
    return {}
  },
  computed: {
    showOrderModeSwitcher() {
      return store.getters.showOrderModeSwitcher
    },
    availableOrderModes() {
      return store.getters.availableOrderModes
    },

    kiekName() {
      try {
        let kiekCat = store.getters.foodMenu.find(c => c.categoryDE.startsWith('Kiek'));
        return kiekCat.categoryDE;
      } catch (e) {
        return ''
      }
    },

    lastOrdersPayableInhouse() {
      let list = util.cloneMe(store.getters.lastOrders);
      let r = [];
      if (store.getters.inhouse && store.getters.enableCheckouInhouseTable) {
        for (let o of list) {
          if (o.usecase === qconst.usecase$tableOrdering
            && o.table === store.getters.table
            && o.sentToPos && !o.sentPaymentToPos && !o.storno) {
            r.push(o);
          }
        }
      }
      return r;
    },
    unreadNews() {
      return store.getters.unreadNews;
    },
    numberOfFavs() {
      return store.getters.numberOfFavs;
    }
    // numberOfFavs() {
    //     let favFoods = [];
    //     let favs = util.cloneMe(store.getters.favFoods);
    //     for (let favFood of favs) {
    //         let foodItem = store.getters.getFoodById(favFood.id);
    //         if (!foodItem) {
    //             //ignore items that do not exist
    //             continue;
    //         }
    //         // if ('image' in foodItem) {
    //         //     favFood.image = foodItem.image;
    //         // }
    //         favFoods.push(favFood);
    //     }
    //     // if (favFoods.length === 0) {
    //     let lsFavFoods = this.$ls.get('favFoods');
    //     if (lsFavFoods) {
    //         let fv = JSON.parse(lsFavFoods);
    //         for (let v of fv) {
    //             //ignore items that already exist
    //             if (this.containsItemId(favFoods, v.id)) {
    //                 continue
    //             }
    //
    //             let foodItem = store.getters.getFoodById(v.id);
    //             if (!foodItem) {
    //                 //ignore items that do not exist
    //                 continue;
    //             }
    //             // if ('image' in foodItem) {
    //             //     v.image = foodItem.image;
    //             // }
    //             favFoods.push(v);
    //         }
    //     }
    //     return favFoods.length;
    // },
    // unfilteredCategories() {
    //     return util.cloneMe(this.foodCategories);
    // },
  },
  beforeMount() {
    this.checkEnter();
  },
  created() {
    this.checkEnter();
    // ebus.$on('inhouse', () => {
    //     this.checkEnter();
    // });
  },
  mounted() {
    console.log('mounted Home...');
    store.commit('showLoading', false);
    this.$nextTick(() => {
      this.lazySelectOrderMode();

      if (this.checkEnter()) {
        this.init();

        setTimeout(() => {
          store.commit('showLoading', false);
          this.checkEnter();
        }, 1500);

        setTimeout(() => {
          if (store.getters.lastOrders.length === 0) {
            ebus.$emit('loadLastOrders');
            this.checkEnter();
          }
        }, 3500);
      }
      if (window.innerWidth < 800) {
        window.addEventListener('scroll', this.handleScroll);
      }
      // ebus.$emit('showScrollDown', true);
      // let sd = document.getElementById('scrollDown');
      // sd.style.opacity = '0';
      // sd.style.pointerEvents = 'none';
      // // logPageView('Home')
      // if (window.innerWidth < 800) {
      //     window.addEventListener('scroll', this.handleScroll);
      // }
    });
  },
  destroyed() {
    // let sd = document.getElementById('scrollDown');
    // sd.style.opacity = '1';
    // sd.style.pointerEvents = 'all';
    //
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapMutations(['setSelectedOrderModeByUser']),

    lazySelectOrderMode() {
      if (!store.state.enableOrderModeSelection) {
        return;
      }

      if (store.getters.isKiosk) {
      } else {
        if (this.availableOrderModes.length === 1 && !store.getters.selectedOrderModeByUser) {
          let availableMode = this.availableOrderModes[0];
          if (availableMode === usecase$takeAway) {
            console.log('lazySelectOrderMode ' + availableMode);
            store.commit('setSelectedOrderModeByUser', usecase$takeAway)
          } else if (availableMode === usecase$delivery) {
            console.log('lazySelectOrderMode ' + availableMode);
            store.commit('setSelectedOrderModeByUser', usecase$delivery)
          }
        }
      }
    },

    showInstall() {
      return !isIos();
    },

    clickInstallApp() {
      ebus.$emit('installPrompt');
    },
    gotoKiek() {
      let kiekCat = store.getters.foodMenu.find(c => c.categoryDE.startsWith('Kiek'));
      if (kiekCat) {
        ebus.$emit('goto', {name: 'SpeisenProdukte', params: {catname: kiekCat.categoryDE}, scrollTarget: ''})
      }
    },
    debugSound() {
      ebus.$emit('inAppNotify');
    },
    init() {

    },
    handleScroll(event) {
      // console.log('Scroll: ' + (window.scrollY + window.innerHeight) + ' from ' + document.body.clientHeight);

      try {
        document.querySelectorAll('.away').forEach((a) => {
          a.style.opacity = 1 - (window.scrollY / 250);
        });
      } catch (e) {
        console.log('Error on scroll: ' + e.message);
      }

    },
    checkEnter() {
      if (store.getters.isKiosk) {
        if (store.getters.showKioskSplashOnHome) {
          this.$router.replace({name: 'KioskSplashScreen'});
        } else {
          this.$router.replace({name: 'Sortiment'});
        }

        return false;
      }
      // if (
      //     // (!this.$ls.get('asGuest',true) && store.getters.loggedIn === false) ||
      //     store.getters.inhouse
      // ) {
      //     this.$router.replace({name: 'Sortiment'});
      //     return false;
      // }
      return true;
    },
    // chooseUsecase(uc) {
    //   // store.commit('selectedUsecase', uc);
    //   this.gotoSortiment();
    // },
    gotoSortiment() {
      this.$router.push({name: 'Sortiment'});
    },
    gotoSpeisen() {
      ebus.$emit('shortcutToFoodMenu');
    },
    gotoDrinks() {
      ebus.$emit('shortcutToDrinkMenu');
    },
    gotoAbholzeiten() {
      this.$router.push({name: 'Abholzeiten'});
    },
    gotoAktuelles() {
      this.$router.push({name: 'Aktuelles'});
    },
    gotoLastOrders() {
      this.$router.push({name: 'Bestellungen'});
    },
    gotoShop() {
      ebus.$emit('showInfo', {
        title: 'TODO',
        text: 'Wird bearbeitet',
      });
    },
    goKellnerruf() {
      this.$router.push({name: 'Kellnerruf'});
    },
    // gotoWebsite(url) {
    //     let win = window.open(url, '_blank');
    //     win.focus();
    // },
    gotoCheckin() {
      ebus.$emit('showInfo', {
        title: 'TODO',
        text: 'Wird bearbeitet',
      });
      // if (qconst.forceTableScan) {
      //     if (this.$store.getters.table > 0) {
      //         let ok = false;
      //         let link = lucaUtil.getLucaLink(this.$store.getters.table);
      //         if (link) {
      //             ok = true;
      //             console.log('open luca link: '+link);
      //             this.gotoWebsite(link);
      //         }
      //
      //         if (!ok) {
      //             ebus.$emit('suggestQrCodeScan');
      //         }
      //     } else {
      //         ebus.$emit('suggestQrCodeScan');
      //     }
      // }
    }
  },
  // handleScroll(event) {
  //     // console.log('Scroll: ' + (window.scrollY + window.innerHeight) + ' from ' + document.body.clientHeight);
  //
  //     try {
  //         document.getElementById('away').style.opacity = 1 - (window.scrollY / 250);
  //     } catch (e) {
  //         console.log('Error on scroll: ' + e.message);
  //     }
  //
  // },
  // updateUserName() {
  //     try {
  //         this.userName = '';
  //         // let user = firebaseUtil.getUser();
  //         // if (user && user.displayName && user.displayName.length > 3) {
  //         //     this.userName = user.displayName;
  //         // }
  //     } catch (e) {
  //
  //     }
  // },
  init() {
    // let foodCats = util.cloneMe(store.getters.foodMenu);
    // // for (let fcat of foodCats) {
    // //     if (!fcat.items) {
    // //         continue;
    // //     }
    // //     for (let item of fcat.items) {
    // //         let offerAndItem = store.getters.getOfferByItemId(item.id);
    // //         // item.offered = !!offerAndItem;
    // //         // if (!!offerAndItem) {
    // //         //     item.offerId = offerAndItem.offer.id;
    // //         // }
    // //         this.applyOfferAndPrices(item, offerAndItem);
    // //     }
    // // }
    // this.foodCategories = foodCats;
  },
  // containsItemId(items, id) {
  //     for (let item of items) {
  //         if (item.id === id) {
  //             return true;
  //         }
  //     }
  //     return false;
  // },


}
</script>
<style scoped lang="scss">
@import '../styles/base';

.page {
  height: 100%;
}

.logoContainer {
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
  height: 100%;
}

.cc {
  padding-bottom: 0 !important;
}

$heightLogos: 200px;

.logoPadding {
  padding-bottom: $heightLogos - 20px;
}

.absLogosBottom {
  height: $heightLogos;
  max-height: $heightLogos;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.bottomLogo {
  max-height: $heightLogos;
}

.homeCard {
  position: relative;
}

.mActions {
  color: white;
  padding-bottom: 15px;
}

.heroImage ::v-deep .v-image__image {
  background-position: 50% 20% !important;
}

.mAction {

  img {
    width: 35px;
    height: auto;
  }
}

.device-xs {
  .mAction {
    padding: 10px;
  }
}

.home ::v-deep .cardContent {
  //@extend .cardGradient;
  z-index: 3;
  height: 100%;

  padding: 0 6px;

  background-color: transparent;

  /*background-position: center;*/
  /*background-repeat: no-repeat;*/
  /*background-size: cover;*/
  /*background-image: url('../assets/qrito_resturant.jpg');*/
  /*backdrop-filter: opacity(30%);*/
}

//within mobile
.restLogoContainer {
  padding: 15px 15px 10px 15px;
  /*<!--background-color: rgba($color-primary, 0.6);-->*/
  /*border-bottom-left-radius: 20px;*/
  /*border-bottom-right-radius: 20px;*/
}

.restLogo {
  width: 100%;
  max-width: 220px;
}

//within tablet
.tabletLogo {
  position: absolute;
  top: 30px;
  left: 20px;
  text-align: left;

  max-width: 490px;

  img {
    display: inline-block;
    max-height: 300px;
    max-width: 450px;
    /*width: 360px;*/
  }
}

.appImage {
  display: inline-block;
  height: 220px;
  width: 230px;
  border: 3px solid $accent;

  background-repeat: no-repeat;
  background-size: cover;
  /*background-image: url('../assets/err');*/
}


.mHero {
  padding-top: 320px;
  /*padding-top: 405px;*/
  position: relative;
  /*background-position: top center; //focused corner is bottom left*/
  /*background-repeat: no-repeat;*/
  /*background-size: cover;*/
  /*background-image: url('../assets/bg2.jpg');*/
  /*filter: brightness(120%);*/

}

.fixBg {
  position: fixed;
  top: 0;
  /*    left: 0;*/
  padding-top: 100px; //$headHeight
  height: var(--layout-height);
  width: var(--layout-width);
  //background-color: $color-primary;
  background-position: 70% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  //background-image: url('../assets/restaurant.jpg');
  /*    !*backdrop-filter: brightness(120%);*!*/
}

.mActionsContainer {
  text-align: center;
  /*border-radius: 25px;*/
  /*border-top-left-radius: 25px;*/
  /*border-top-right-radius: 25px;*/
  /*background-color: white;*/
  z-index: 2;
  position: relative;
  overflow: hidden;

  //background-color: rgba($color-darkblue, 0.8);
}

</style>
